import { getFragmentData } from "@/__generated__";
import type { VisitQuery, VisitQueryVariables } from "@/__generated__/graphql";
import { VisitClientFragmentFragmentDoc, VisitDocument } from "@/__generated__/graphql";
import { mapToVisitDetailData } from "@/components/shared/visits/visit-detail";
import { useQuery, type QueryHookOptions } from "@apollo/client";

export const useVisitByIdQuery = (options?: QueryHookOptions<VisitQuery, VisitQueryVariables>) => {
  const result = useQuery(VisitDocument, options);

  const visitDetailData = result.data?.visit
    ? mapToVisitDetailData(getFragmentData(VisitClientFragmentFragmentDoc, result.data.visit))
    : null;

  return {
    ...result,
    data: visitDetailData,
  };
};
